import { PortalIcon, type PortalIconProps } from './portal-icon';

/** Palette — display settings. */
export function PaletteIcon(props: PortalIconProps) {
  return (
    <PortalIcon {...props}>
      <path d="M12 4a8 8 0 1 0 0 16c1.4 0 2-.8 2-1.8 0-.9-.7-1.4-.7-2.3 0-1 .8-1.7 1.9-1.7h2.2c1.1 0 1.9-.8 1.9-1.9C19.3 8.1 15.9 4 12 4Z" />
      <path d="M8.2 10.4h.01M11.4 7.6h.01M15.6 9.6h.01M8.8 14.8h.01" />
    </PortalIcon>
  );
}
